import TextField from "@mui/material/TextField";
import {
  FilledTextFieldProps,
  OutlinedTextFieldProps,
  StandardTextFieldProps,
  TextFieldProps,
} from "@mui/material";
import addTaskVector from "../assets/images/addTaskVector.svg";
interface InputTextFieldProps extends StandardTextFieldProps {
  hasIcon?: boolean;
}
export const InputTextField: React.FunctionComponent<InputTextFieldProps> = (
  props
) => {
  return (
    <TextField
      onWheel={(e:any) => e?.target?.blur()}
      variant={props.variant ?? "filled"}
      {...props}
      fullWidth={true}
      InputProps={{
        endAdornment: (
          <>{props.hasIcon ? <img src={addTaskVector} /> : <></>}</>
        ),
      }}
    />
  );
};
export default InputTextField;
// import { TextField, ITextField, ITextFieldProps, constructKeytip, ITextFieldStyles } from '@fluentui/react';
// import React from 'react';

// const inputStyles: ITextFieldStyles = {
//   root: {
//     marginBottom: "15px"
//   },
//   fieldGroup: {
//     'input': {
//       color: "#9D9D9D",
//       fontFamily: "GilroyRegular",
//       fontSize: "19px",
//       fontStyle: "normal",
//       fontWeight: 400,-
//       lineHeight: "23px",
//       letterSpacing: "0em",
//       textAlign: "left"
//     },
//     border: 0,
//     height: "51px",
//     borderRadius: "12px"
//   },
//   prefix: undefined,
//   suffix: undefined,
//   field: undefined,
//   icon: undefined,
//   description: undefined,
//   wrapper: undefined,
//   errorMessage: undefined,
//   subComponentStyles: { label: {} },
//   revealButton: undefined,
//   revealSpan: undefined,
//   revealIcon: undefined
// }

// export default class InputTextField extends React.Component<ITextFieldProps, { value: string, isTouched: boolean }> {
//   constructor(props: any) {
//     super(props);
//     this.setValue = this.setValue.bind(this);
//     this.state = {
//       value: String(),
//       isTouched: false
//     }
//   }

//   setValue(e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) {
//     this.setState({ value: e.currentTarget.value });
//     if (this.props.onChange) this.props.onChange(e);
//   }
//   render() {
//     let inputTextFieldClassName = `${this.state.value || this.props.value ? ' not-empty' : String()}`;
//     inputTextFieldClassName += (this.props.readOnly && !this.props.value) ? ' read-only' : String();
//     //${this.state.isTouched && this.props.invalid ? ' invalid-input' : String()}
//     return (
//       <div className={inputTextFieldClassName}>
//         {/* onBlur={(e) => { return this.setState({ isTouched: true }) }}  */}
//         <TextField invalid={this.state.isTouched && this.props.invalid}
//           label={this.props.label ?? this.props.placeholder} {...this.props}
//           onChange={(e) => { this.setValue(e) }}
//           styles={{ ...inputStyles, ...this.props.styles }} />
//       </div>
//     );
//   }
// }
